
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/model';
import { InAppNotificationClient } from '@/services/Services';
import store from '@/store';
import { Prop } from 'vue-property-decorator';
import villageTripBookAnswer from './villageTripBookAnswer.vue'

@Options({
    components: {
        villageTripBookAnswer
    }
})
export default class inAppNotifications extends Vue {

    @Prop() item: OM.InAppNotification;

}
